/** @jsx jsx */
import { jsx } from '@emotion/core';
import styled from '@emotion/styled';
import * as style from './index.styles';

const I = styled.i(style, props => {
  delete props.className;

  return props;
});

/**
 * Documentation at:
 * https://github.hugeinc.com/HugeTechnology/IWG/wiki/Font-Icons
 * @deprecated should use icomoon instead.
 * @param {!Object} props Object with the icon name.
 * @param {Object} css Object with custom styles.
 * @returns {Component}
 */
export const Icon = props => {
  const { name, customCss = {}, className, svgIcon } = props;
  if (svgIcon != null) {
    return (
      <div css={style.svgicon16}>
        <img src={svgIcon} alt="svgIcon" css={[style, customCss]} />
      </div>
    );
  } else {
    return (
      <I
        css={[style, customCss]}
        className={`icon icon-${name} ${className}`}
      />
    );
  }
};
Icon.displayName = 'Icon';
